import differenceWith from 'lodash/differenceWith';
import isEqual from 'lodash/isEqual';
import union from 'lodash/union';

// Hooks
import {
    ADD_MEDIAS,
    REMOVE_ALL_MEDIA,
    useAlbumContext
} from '@/utils/hooks/context/useAlbumContext';
import useTranslation from '@/utils/hooks/translation/useTranslation';
import useActiveSocialProfile from '@/utils/hooks/user/useActiveSocialProfile';

import { TWITTER } from '@/lib/socialProfile';

// Components
import Icon from '@/components/base/Icon';

const MediaSelectionSection = ({ dataMedias }) => {
    const { t } = useTranslation('content');
    const { albumInfo, dispatch } = useAlbumContext();
    const { activeSocialProfile } = useActiveSocialProfile();
    const network = activeSocialProfile?.social_network_type;

    const typePost = albumInfo?.criteria?.album_type === 'stories' ? 'stories' : 'medias';

    let allVisibleMedias = [];
    dataMedias?.map((medias) => {
        let allMedias = medias?.[typePost]?.map((media) => {
            return media?.id;
        });
        allVisibleMedias = union(allVisibleMedias, allMedias);
    });

    return (
        <div className="flex flex-wrap justify-between gap-3">
            <div className="flex space-x-2 px-2 text-sm">
                <Icon icon="albums" className="text-icoBlue" />
                <span>
                    {network === TWITTER ? t('modal.selected_tweets') : t('modal.selected_medias')}:
                </span>
                <span className="text-icoBlue">{albumInfo?.medias?.length ?? 0}</span>
            </div>
            <div className="space-x-5 text-xs text-icoBlue">
                {albumInfo?.medias?.length ? (
                    <button onClick={() => dispatch({ type: REMOVE_ALL_MEDIA })}>
                        {t('modal.edit_modal.unselect_all_posts')}
                    </button>
                ) : null}
                {dataMedias &&
                dataMedias?.[0]?.[typePost]?.length &&
                differenceWith(allVisibleMedias, albumInfo?.medias, isEqual).length ? (
                    <button
                        onClick={() =>
                            dispatch({
                                type: ADD_MEDIAS,
                                payload: allVisibleMedias
                            })
                        }>
                        {t('modal.select_all_visible_posts')}
                    </button>
                ) : null}
            </div>
        </div>
    );
};

export default MediaSelectionSection;
